import { __assign } from "tslib";
import { createFakePostResponder, createFakeDeleteResponder } from './../../test-utils';
import { createFakeGetResponder } from '../../test-utils';
// tslint:disable-next-line:max-line-length
import { sendingDomainUri, createEmailDomainApi, emailNotificationUri, sendingDomainsUri } from './index';
import { createHttpTestKit } from '../../http/test-kit';
export var createEmailDomainApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createEmailDomainApi('', fakeHttp);
    var sendingDomainsTestKit = {
        whenGetAllSendingDomains: function () { return createFakeGetResponder(fakeHttp, "/" + sendingDomainsUri); },
        whenGetSendingDomain: function (id) { return createFakeGetResponder(fakeHttp, "/" + sendingDomainsUri + "/" + id); },
        whenAddSendingDomain: function (domain) { return createFakePostResponder(fakeHttp, "/" + sendingDomainsUri)({ domain: domain }); },
        whenDeleteSendingDomain: function (id) { return createFakeDeleteResponder(fakeHttp, "/" + sendingDomainsUri + "/" + id); },
        whenValidateSendingDomain: function (id) { return createFakeGetResponder(fakeHttp, "/" + sendingDomainsUri + "/" + id + "/isValid"); },
        whenSetDefaultSendingDomain: function (id) { return createFakePostResponder(fakeHttp, "/" + sendingDomainsUri + "/" + id + "/default")({}); },
        whenEditSendingDomain: function (dto) {
            if (dto === '*') {
                return createFakePostResponder(fakeHttp, dto)(dto);
            }
            return createFakePostResponder(fakeHttp, "/" + sendingDomainsUri + "/" + dto.id + "/edit")(dto);
        },
    };
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenGetCustomSendingDomain: function () {
            return createFakeGetResponder(fakeHttp, "/" + emailNotificationUri + "/" + sendingDomainUri);
        },
        whenSetCustomSendingDomain: function (domainName) {
            return createFakePostResponder(fakeHttp, "/" + emailNotificationUri + "/" + sendingDomainUri + "?domain=" + domainName)({});
        },
        whenValidateCustomSendingDomain: function () {
            return createFakePostResponder(fakeHttp, "/" + emailNotificationUri + "/" + sendingDomainUri + "/validate")();
        },
        whenDeleteCustomSendingDomain: function () {
            return createFakeDeleteResponder(fakeHttp, "/" + emailNotificationUri + "/" + sendingDomainUri);
        },
        sendingDomainsTestKit: sendingDomainsTestKit,
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map